import React from 'react';
import {
  CircularProgress,
  MenuItem,
  Typography,
} from '@mui/material';
import { HookFormSelect } from '../../common/components';
import * as Roles from '../constants/Role';
import { GET_ROLE_OPTIONS_QUERY } from '../gql/Query';
import { useQuery } from '@apollo/client';
import { startCase } from 'lodash';
import clientGraphql from '../../../common/apollo-graphql';
import { useWatch } from 'react-hook-form';

export default function RoleOptions({ prefix = null, name = 'role_id', control, errors, disabled = false }) {

  const roleId = useWatch({
    control,
    name: name
  });

  const hasProviderRole = parseInt(roleId, 10) === Roles.ROLE_PROVIDER['id'];

  const { loading, data } = useQuery(
    GET_ROLE_OPTIONS_QUERY,
    {
      client: clientGraphql,
      variables: {
        excludedRoles: [Roles.ROLE_ADMIN['value'], Roles.ROLE_PROVIDER['value']]
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      skip: hasProviderRole
    }
  );

  if (loading) return <CircularProgress />;

  if (hasProviderRole) {
    return (
      <div>
        <Typography variant="body1" fontWeight='bold'>Provider</Typography>
      </div>
    );
  } else

  return (
    <HookFormSelect
      id={name}
      type="select"
      select
      name={name}
      placeholder="Select role"
      label="Role *"
      schema={name}
      prefix={prefix}
      control={control}
      errors={errors}
      fullWidth
      disabled={disabled}
    >
      {
        data &&
        data.rows.map((option) => (
          <MenuItem key={option.name} value={parseInt(option.id, 10)}>
            {startCase(option.name)}
          </MenuItem>
        ))
      }
    </HookFormSelect>
  );
}